export enum DeviceSetupScreens {
  ScreenCasting = 'casting_faq',
  Instructor = 'instructor_settings',
  HeartRate = 'heart_rate_scan',
  MyWorkout = 'workout_settings',
  VideoCall = 'video_call_settings',
  ScreenMirror = 'mirror_settings',
  Music = 'music_change',
  LeaderboardSetup = 'leaderboard_settings',
  WorkoutTypeWarning = 'workout_type_warning',
}
